export const REQUEST_BOOKING_SEARCH = 'REQUEST_BOOKING_SEARCH';
export const RECEIVE_BOOKING_SEARCH = 'RECEIVE_BOOKING_SEARCH';
export const SET_BOOKING_SEARCH_FAILURE = 'SET_BOOKING_SEARCH_FAILURE';
export const CLEAR_BOOKING_SEARCH_ERROR_MESSAGE = 'CLEAR_BOOKING_SEARCH_ERROR_MESSAGE';
export const SET_BOOKING_DATA_FROM_COOKIE = 'SET_BOOKING_DATA_FROM_COOKIE';
export const SET_BOOKING_SEARCH_LOGIN_DENIED = 'SET_BOOKING_SEARCH_LOGIN_DENIED';
export const REQUEST_BOOKING_BALANCE = 'REQUEST_BOOKING_BALANCE';
export const RECEIVE_BOOKING_BALANCE = 'RECEIVE_BOOKING_BALANCE';
export const SET_BOOKING_BALANCE_FAILURE = 'SET_BOOKING_BALANCE_FAILURE';
export const SET_SHOW_APP_MODAL = 'SET_SHOW_APP_MODAL';
export const SET_SITE_CODE = 'SET_SITE_CODE';
